(function () {
    'use strict';
    /* global _ */

    angular
        .module('surveyControllers')
        .controller('SurveyQuestionFreeTextDefaultController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        // Init Model
        if (_.isUndefined($scope.question.Responses)) {
            $scope.question.Responses = [{ QuestionID: $scope.question.CampaignComponentID }];
        } else if ($scope.question.Responses.length > 1) {
            $scope.showTooManyResponsesErrorAlert();
        }
        $scope.questionResponse = $scope.question.Responses[0];

        // Update FreeText
        $scope.updateFreeTextResponse = function () {
            if (!$scope.question.IsFreeText) { return; }

            $scope.toAddResponse()($scope.question, $scope.questionResponse)
                .then(function (updatedResponse) {
                    if (!updatedResponse.SurveyResponseID) { return; }

                    $scope.questionResponse = updatedResponse;
                });
        };
    }
})();